var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import moment from "moment";
export var mandateTimelineMapper = function (response) {
    var _a;
    if (((_a = response.data) === null || _a === void 0 ? void 0 : _a.length) > 0) {
        return response.data.map(function (item) {
            return __assign(__assign({}, item), { processDate: moment(item.processDate).format("DD MMM YYYY, hh:mm A") });
        });
    }
};
